import { useCallback, useEffect, useState } from 'react';
import { getKalendariumJsonUrl } from '../config/app';

function normalizeEvents(raw) {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    if (Array.isArray(raw.events)) return raw.events;
    return [];
}

export function useKalendarium() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await fetch(getKalendariumJsonUrl(), { cache: 'no-store' });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const json = await res.json();
            const list = normalizeEvents(json);
            setEvents(Array.isArray(list) ? list : []);
        } catch (e) {
            setError(e.message || 'Błąd');
            setEvents([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return { events, loading, error, reload: load };
}
